export default function TrustBar() {
  const items = [
    { icon: 'ri-shield-check-fill', label: 'Licensed & Insured' },
    { icon: 'ri-tools-fill', label: 'Quality Workmanship' },
    { icon: 'ri-user-star-fill', label: 'Owner on Every Job' },
    { icon: 'ri-time-fill', label: 'On-Time Delivery' },
    { icon: 'ri-home-4-fill', label: 'Residential Specialists' },
  ];

  return (
    <section className="relative bg-[#111] py-0 overflow-hidden">
      {/* Gold top border */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#C9A87C] to-transparent"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-0 divide-y md:divide-y-0 md:divide-x divide-white/6">

          {/* Stars + label */}
          <div className="flex items-center gap-4 py-5 md:py-6 md:pr-10 flex-shrink-0">
            <div className="flex gap-0.5">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-[#C9A87C] text-base"></i>
              ))}
            </div>
            <div>
              <p
                className="text-white font-bold text-sm leading-tight"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                5-Star Rated
              </p>
              <p
                className="text-white/40 text-[10px] uppercase tracking-widest"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                Local Contractor
              </p>
            </div>
          </div>

          {/* Credentials */}
          <div className="flex flex-wrap justify-center md:justify-start gap-0 flex-1 divide-x divide-white/6">
            {items.map((item, i) => (
              <div
                key={i}
                className="flex items-center gap-2.5 px-6 py-5 md:py-6 group hover:bg-white/3 transition-colors duration-200"
              >
                <div className="w-8 h-8 flex items-center justify-center bg-[#B8956A]/15 flex-shrink-0">
                  <i className={`${item.icon} text-[#C9A87C] text-sm`}></i>
                </div>
                <span
                  className="text-white/60 text-xs font-semibold tracking-wide whitespace-nowrap"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Gold bottom border */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#C9A87C]/30 to-transparent"></div>
    </section>
  );
}
